// extracted by mini-css-extract-plugin
export default {"mainLayout":"TermsLayout_mainLayout__gUEZ0","MainBody":"TermsLayout_MainBody__bU9Ra"};